import "./CopyCodeTabs.scss";

import React, { useState } from "react";
import { Button, Nav, NavDropdown, Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useCopyToClipboard } from "usehooks-ts";

import { CodeHighlight } from "../CodeHighlight";
import { RocketIcon } from "../icons";
import { JsonEditor } from "../JsonEditor";
import { defaultMessages, getCodeList } from "./constants";

interface CopyCodeTabsProps {
  messages?: string;
  isStream?: boolean;
  model?: string;
  seed?: number | null;
  tools?: any;
  cacheControl?: string;
}

const CopyCodeTabs: React.FC<CopyCodeTabsProps> = ({
  messages = defaultMessages,
  isStream = true,
  model = "COGCACHE_LLM_MODEL",
  tools,
  seed,
  cacheControl = "public",
}) => {
  const codeList = getCodeList(
    messages,
    isStream,
    model,
    tools,
    cacheControl,
    seed,
  );
  const [selectedKey, setSelectedKey] = useState(codeList.main[0].key);

  const [_, copy] = useCopyToClipboard();

  const copyToClipboard = (code: string) => {
    copy(code)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch(console.error);
  };

  return (
    <>
      <div className="code-tabs">
        <Nav activeKey={selectedKey}>
          {codeList.main.map(({ key, type }) => (
            <Nav.Item key={key}>
              <Nav.Link eventKey={key} onClick={() => setSelectedKey(key)}>
                {type}
              </Nav.Link>
            </Nav.Item>
          ))}
          <NavDropdown title="LangChain" id="nav-dropdown">
            {codeList.lang.map(({ key, type }) => (
              <NavDropdown.Item
                key={key}
                eventKey={key}
                onClick={() => setSelectedKey(key)}
              >
                {type}
              </NavDropdown.Item>
            ))}
          </NavDropdown>
        </Nav>

        <Tabs activeKey={selectedKey}>
          {[...codeList.main, ...codeList.lang].map(
            ({ code, key, codeType, type }) => (
              <Tab eventKey={key} title={type} key={key}>
                <div className={`dimension-wrap code-${key}`}>
                  <CodeHighlight code={code} codeType={codeType} />
                </div>
                <Button
                  onClick={() => copyToClipboard(code)}
                  className="fw-bold flex-shrink-0 d-flex align-items-center gap column-gap-2 mb-4"
                >
                  <RocketIcon size={16} />
                  Copy code
                </Button>
              </Tab>
            ),
          )}
        </Tabs>
      </div>
      <p className="text-center">
        Your API key can be found <Link to="/organization/keys">here</Link>. You
        should use environment variables or a secret management tool to expose
        your key to your applications.
      </p>
    </>
  );
};

export { CopyCodeTabs };
